import { Box, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IButtonContainerProps {
  variant: 'teal' | 'green';
  title: string;
  description: string;
  ButtonComponent: React.ReactNode;
  FooterComponent?: React.ReactNode;
  disabled?: boolean;
  showNewBadge?: boolean;
}

const variantStyles = {
  teal: {
    background: 'linear-gradient(135deg, #2A6C7E 0%, #2F7A8D 50%, #348A9E 100%)',
  },
  green: {
    background: 'linear-gradient(135deg, #028A7E 0%, #01D1BB 100%)',
  },
};

export const ButtonContainer = ({
  variant,
  title,
  description,
  ButtonComponent,
  FooterComponent,
  disabled,
  showNewBadge = false,
}: IButtonContainerProps) => {
  const styles = variantStyles[variant];

  return (
    <Box
      background={styles.background}
      borderRadius={25}
      boxShadow="2px 6px 16px 0 rgba(0, 0, 0, 0.16)"
      flex={1}
      opacity={disabled ? 0.7 : 1}
      position="relative"
      overflow="hidden"
    >
      <Box
        paddingHorizontal={26}
        paddingTop={20}
        paddingBottom={FooterComponent ? 16 : 26}
        gap={6}
      >
        {showNewBadge && (
          <Box
            position="absolute"
            top={0}
            right={0}
            width="auto"
            style={{
              overflow: 'visible',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="60"
              viewBox="0 0 57 60"
              fill="none"
            >
              <path
                d="M31.9971 0C45.8042 0 56.9971 11.1929 56.9971 25V59.9971L0 0H31.9971Z"
                fill="#51D2DB"
              />
            </svg>
            <Text
              position="absolute"
              top={14}
              right={4}
              color={Colors.white}
              fontSize={14}
              bold
              style={{
                transform: 'rotate(46.71deg)',
                transformOrigin: 'center',
                textTransform: 'uppercase',
              }}
            >
              NEW
            </Text>
          </Box>
        )}
        <Text color={Colors.white} fontSize={24} bold>
          {title}
        </Text>
        <Row
          alignItems="flex-start"
          justifyContent="space-between"
          gap={17}
        >
          <Text color={Colors.white} flex={1}>
            {description}
          </Text>
          {ButtonComponent}
        </Row>
      </Box>
      {FooterComponent}
    </Box>
  );
};
